import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    imports:[RouterModule]
})
export class ErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
